import { MenuItemProps } from '@sketch-note/design-system/src/components/menu';
// import { StopCircle } from '@sketchnote/icons';
import { AlertIcon, BellIcon, ExpandIcon, LeftArrowIcon, RightArrowIcon } from '@sketchnote/icons';
import { Button } from '@sketchnote/shared-components';
import classNames from 'classnames';
import { frontendHostUrl } from 'config';
import { differenceInCalendarDays } from 'date-fns';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useMemo } from 'react';
import { useSocketComment, useSocketNotification, useSocketSyncOrg } from 'src/api';
import { AiPopover } from 'src/components/Create-with-ai';
import { isAdvUser, isIndieUser, isProUser } from 'src/constants/plans';
// import { StopTimer } from 'src/features/tasks/components/stopTimer';
import { useAuth } from 'src/shared/hooks/use-auth';

import { ProfilePopover } from '../profile-popup';

export interface CommonNavbarProps {
  isSideBarOpen?: boolean;
  isRightArrowDisabled?: boolean;
  isLeftArrowDisabled?: boolean;
  onLeftIconClick?: ((event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void) | undefined;
  onRightIconClick?: ((event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void) | undefined;
  notificationCount?: number;
  searchPlaceholder?: string;
  wrapperClassName?: string;
  onNotificationClick?:
    | ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  onSearchChange?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | undefined;
  handleToggleSideBar?:
    | ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  username: string;
  onHelp?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onProfileMenuClick?: (e: MenuItemProps) => void;
  onOrganisationClick?: (e: MenuItemProps) => void;
  onSearchOpen?: () => void;
  authData: any;
}

export const CommonNavbar = ({
  isSideBarOpen,
  isRightArrowDisabled,
  isLeftArrowDisabled,
  notificationCount = 0,
  searchPlaceholder = 'Search...',
  wrapperClassName,
  onNotificationClick,
  handleToggleSideBar,
  onSearchChange,
  onHelp,
  onProfileMenuClick,
  onSearchOpen,
  authData,
}: CommonNavbarProps): JSX.Element => {
  const router = useRouter();
  // const { isStopTimerModalOpen, setIsStopTimerModalOpen } = useLayout();
  const leftArrowIconClasses = classNames({
    'text-gray-500': !isLeftArrowDisabled,
    'text-gray-200': isLeftArrowDisabled,
  });
  const RightArrowIconClasses = classNames({
    'text-gray-500': !isRightArrowDisabled,
    'text-gray-200': isRightArrowDisabled,
  });
  const wrapperClasses = classNames({
    'flex  items-center border-b justify-between border-gray-200 p-8 px-16 z-200 bg-white': true,

    [wrapperClassName || '']: !!wrapperClassName,
  });
  function handleBackwardNavigation() {
    router.back();
  }
  function handleForwardNavigation() {
    window.history.forward();
  }

  const fetchUserDetails = useAuth((s) => s.fetchUserDetails);

  const socketSyncOrg = useSocketSyncOrg({
    organisation: authData?.memberInformation?.organisation?.organisationId,
  });
  const socketNotification = useSocketNotification();
  const socketComment = useSocketComment();
  const planDeadline = useMemo(
    () =>
      authData?.plan?.expiry
        ? differenceInCalendarDays(new Date(), new Date(authData?.plan?.expiry))
        : 0,
    [authData?.plan?.expiry]
  );

  useEffect(() => {
    fetchUserDetails();
  }, [socketSyncOrg, socketComment, socketNotification]);

  return (
    <nav className={wrapperClasses}>
      <div className="flex items-center">
        {!isSideBarOpen ? (
          <Button
            onClick={handleToggleSideBar}
            className="pl-0 pr-0 mr-32 cursor-pointer"
            status="ghost"
            iconLeft={<ExpandIcon wrapperClass="text-gray-500" size={16} />}
          />
        ) : (
          <div />
        )}
        {authData?.authentication === 'authorised' ? (
          <button tabIndex={-1} onClick={handleBackwardNavigation} className="mr-18 cursor-pointer">
            <LeftArrowIcon wrapperClass={leftArrowIconClasses} />
          </button>
        ) : (
          <div />
        )}
        {authData?.authentication === 'authorised' ? (
          <button tabIndex={-1} onClick={handleForwardNavigation} className="cursor-pointer">
            <RightArrowIcon wrapperClass={RightArrowIconClasses} />
          </button>
        ) : (
          <span />
        )}
      </div>

      <div className="flex items-center self-end">
        {isAdvUser(authData?.plan?.type) && !authData?.plan?.trial && (
          <AiPopover level={'dashboard'} />
        )}
        {/* {authData?.authentication === 'authorised' && authData?.timer?.isRunning && (
          <div className="mt-2">
            <Tippy
              interactive
              className="w-221 h-auto bg-blue-500 tippy text-sm"
              arrow={false}
              content={
                <div>
                  <div>
                    Timer running for
                    <br />
                    <br />
                    <span className="font-medium">{authData?.timer?.board_title}</span> &gt;{' '}
                    <span className="font-medium">{authData?.timer?.task_title}</span>
                  </div>

                  <Link
                    href={`/${router.query.mode}/${router.query.orgId}/tasks/${authData?.timer?.task}?routeBack=default`}
                  >
                    <a className="mt-16 block">
                      Go to task <RightArrowIcon className="text-sm text-white ml-8 pt-4" />
                    </a>
                  </Link>
                </div>
              }
              placement={'bottom'}
            >
              <button onClick={() => setIsStopTimerModalOpen(true)}>
                <div className="flex items-center w-100 mx-16 justify-center">
                  <StopCircle className="mr-4 cursor-pointer hover:opacity-75 mt-2" size={16} />
                  <TimerTracker
                    className="text-xs w-80 text-gray-500 mt-4"
                    startTime={authData?.timer?.startTime}
                    timeTrackedTaskId={authData?.timer?.task}
                    isRunning={authData?.timer?.isRunning}
                  />
                </div>
              </button>
            </Tippy>
          </div>
        )} */}

        {/* {authData?.authentication === 'authorised' ? (
          <button tabIndex={-1} className="help text-sm text-gray-999 font-medium" onClick={onHelp}>
            Help
          </button>
        ) : (
          <span />
        )} */}
        {authData?.authentication !== 'authorised' ? (
          <div className="tablet:flex hidden text-gray-500 text-sm self-end justify-end -mt-2">
            <Link href={'/signin'}>
              <a className="text-center  ml-32 mt-2 py-4 px-16 bg-blue-100 text-blue-500 rounded-sm inline-block">
                Log in
              </a>
            </Link>
            <Link href={'/signup'}>
              <a className="text-center  ml-12 py-4 mt-2 px-16 bg-blue-500 text-white rounded-sm inline-block">
                Sign up for free
              </a>
            </Link>
          </div>
        ) : (
          <span />
        )}

        {authData?.authentication === 'authorised' ? (
          <div className="flex">
            {planDeadline < 14 &&
            planDeadline >= 0 &&
            !authData?.plan?.subscription &&
            authData?.plan?.expiry ? (
              <div
                className={`${
                  planDeadline > 3 ? 'bg-blue-100 text-blue-600' : 'bg-red-100 text-red-500'
                } rounded-sm py-4 px-8 text-sm font-medium`}
              >
                {planDeadline > 0
                  ? `⏳ ${planDeadline} ${authData?.plan?.trial ? 'trial days left' : 'days left'}`
                  : `⏳ Your  ${authData?.plan?.trial ? 'trial plan ' : 'plan'} expires today`}
              </div>
            ) : (
              <></>
            )}
            {isAdvUser(authData?.plan?.type) ? (
              <div className="flex items-center">
                <Link href={`/${router.query.mode}/${router.query.orgId}/pricing`}>
                  <a className="ml-4 text-sm bg-green-100 text-green-700 font-medium rounded-sm px-8 py-4">
                    Advanced plan
                  </a>
                </Link>
              </div>
            ) : isProUser(authData?.plan?.type) ? (
              <div className="flex items-center">
                <Link href={`/${router.query.mode}/${router.query.orgId}/pricing`}>
                  <a className="ml-4 text-sm bg-purple-200 text-purple-799 font-medium rounded-sm px-8 py-4">
                    Pro plan
                  </a>
                </Link>
              </div>
            ) : isIndieUser(authData?.plan?.type) ? (
              <div className="flex items-center">
                <Link href={`/${router.query.mode}/${router.query.orgId}/pricing`}>
                  <a className="ml-4 text-sm bg-primary-300 text-black font-medium rounded-sm px-8 py-4">
                    Indie plan
                  </a>
                </Link>
              </div>
            ) : (
              <div className="flex items-center">
                <Link href={`/${router.query.mode}/${router.query.orgId}/pricing`}>
                  <a className="ml-4 text-sm bg-primary-500 text-white font-medium rounded-sm px-8 py-4">
                    Upgrade
                  </a>
                </Link>
              </div>
            )}
          </div>
        ) : (
          <span />
        )}

        {authData?.authentication === 'authorised' ? (
          <button
            onClick={onNotificationClick}
            className="border gray-500 rounded-full ml-8 mr-4 relative"
          >
            {notificationCount && notificationCount > 0 ? (
              <span
                className="text-xss text-white rounded-full absolute -right-5 -top-5 w-18 h-18 pt-1"
                style={{ backgroundColor: '#375DFB' }}
              >
                {notificationCount > 9 ? '9+' : notificationCount}
              </span>
            ) : (
              <></>
            )}
            <div className="w-30 h-30 rounded-full bg-gray-100 m-1.5">
              <BellIcon className="mt-6" />
            </div>
          </button>
        ) : (
          <></>
        )}
        {authData?.authentication === 'authorised' ? <ProfilePopover /> : <span />}
      </div>

      {/* <Modal isOpen={isStopTimerModalOpen} onClose={() => setIsStopTimerModalOpen(false)}>
        <ModalOverlay />
        <ModalContent
          style={{
            maxWidth: '46rem',
            padding: '32px',
            marginTop: '20rem',
            borderRadius: '8px',
          }}
        >
          <ModalCloseButton />
          <StopTimer
            isRunning={authData?.timer?.isRunning}
            startTime={authData?.timer?.startTime}
            taskId={authData?.timer?.task}
            fileId={authData?.timer?.board}
            taskName={authData?.timer?.task_title}
            fileName={authData?.timer?.board_title}
            type={'common-navbar'}
          />
        </ModalContent>
      </Modal> */}
    </nav>
  );
};
